import React, {Suspense} from "react";
import './styles/App.scss';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import AppRouter from "./provider/router/ui/AppRouter";
import {BrowserRouter} from 'react-router-dom';
import {ContextProviders} from './context/ContextProviders';
import {ThemeProvider} from "./theme/ThemeContext";
import {LinearProgress} from "@mui/material";

const queryClient = new QueryClient();
function App() {
    return (
        <Suspense fallback={<LinearProgress/>}>
            <ThemeProvider>
                <QueryClientProvider client={queryClient}>
                    <ContextProviders>
                        <BrowserRouter>
                            <AppRouter/>
                        </BrowserRouter>
                    </ContextProviders>
                </QueryClientProvider>
            </ThemeProvider>
        </Suspense>
    )

}

export default App;
